import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import RichTextEditor from '@/components/RichTextEditor';
import { PolicyPdfField } from './PolicyPdfField';

export const PolicyFooterCard = ({ formData, setFormData, onRestoreTemplate, onFetchSettings }) => (
  <Card>
    <CardHeader>
      <CardTitle>Rodapé do Canal — Políticas & Documentação</CardTitle>
      <CardDescription>
        Estes documentos ficam disponíveis no rodapé do portal público do seu canal
        (/{'{'}slug{'}'}). Pode colar o conteúdo diretamente ou apontar para um link/PDF externo —
        se ambos estiverem preenchidos, o PDF/link tem prioridade.
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-6">
      {/* Política de Privacidade */}
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label className="text-base font-semibold">Política de Privacidade</Label>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => onRestoreTemplate('privacy')}
            className="text-indigo-700 hover:bg-indigo-50 text-xs"
            data-testid="restore-privacy-template-btn"
          >
            Restaurar do template global
          </Button>
        </div>
        <p className="text-xs text-slate-500">
          Editor com formatação (imagens, listas, links). Alternativas: carregar PDF ou apontar para link externo.
        </p>
        <RichTextEditor
          value={formData.privacy_policy_content}
          onChange={(html) => setFormData(prev => ({ ...prev, privacy_policy_content: html }))}
          placeholder="Cole ou escreva a política de privacidade…"
          testid="privacy-content-editor"
        />
        <PolicyPdfField
          kind="privacy"
          value={formData.privacy_policy_url}
          onChange={(url) => setFormData(prev => ({ ...prev, privacy_policy_url: url }))}
          onUploaded={onFetchSettings}
          testidPrefix="privacy"
        />
        <Input
          placeholder="OU: link externo (ex: https://empresa.com/privacidade)"
          value={formData.privacy_policy_url}
          onChange={(e) => setFormData(prev => ({ ...prev, privacy_policy_url: e.target.value }))}
          data-testid="privacy-url-input"
        />
      </div>

      <Separator />

      {/* Termos de Utilização */}
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label className="text-base font-semibold">Termos de Utilização</Label>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => onRestoreTemplate('terms')}
            className="text-indigo-700 hover:bg-indigo-50 text-xs"
            data-testid="restore-terms-template-btn"
          >
            Restaurar do template global
          </Button>
        </div>
        <RichTextEditor
          value={formData.terms_of_use_content}
          onChange={(html) => setFormData(prev => ({ ...prev, terms_of_use_content: html }))}
          placeholder="Cole ou escreva os termos de utilização…"
          testid="terms-content-editor"
        />
        <PolicyPdfField
          kind="terms"
          value={formData.terms_of_use_url}
          onChange={(url) => setFormData(prev => ({ ...prev, terms_of_use_url: url }))}
          onUploaded={onFetchSettings}
          testidPrefix="terms"
        />
        <Input
          placeholder="OU: link externo"
          value={formData.terms_of_use_url}
          onChange={(e) => setFormData(prev => ({ ...prev, terms_of_use_url: e.target.value }))}
          data-testid="terms-url-input"
        />
      </div>

      <Separator />

      {/* Código de Ética */}
      <div className="space-y-2">
        <Label className="text-base font-semibold">Código de Ética</Label>
        <p className="text-xs text-slate-500">
          Carregue um PDF para hospedagem interna, cole um URL de PDF, ou aponte para uma página web.
        </p>
        <PolicyPdfField
          kind="ethics"
          value={formData.code_of_ethics_pdf_url}
          onChange={(url) => setFormData(prev => ({ ...prev, code_of_ethics_pdf_url: url }))}
          onUploaded={onFetchSettings}
          testidPrefix="ethics"
        />
        <Input
          placeholder="OU: link externo (ex: página web)"
          value={formData.code_of_ethics_url}
          onChange={(e) => setFormData(prev => ({ ...prev, code_of_ethics_url: e.target.value }))}
          data-testid="ethics-url-input"
        />
      </div>

      <Separator />

      {/* PPRCIC */}
      <div className="space-y-2">
        <Label className="text-base font-semibold">PPRCIC — Plano de Prevenção de Riscos de Corrupção e Infrações Conexas</Label>
        <PolicyPdfField
          kind="pprcic"
          value={formData.pprcic_pdf_url}
          onChange={(url) => setFormData(prev => ({ ...prev, pprcic_pdf_url: url }))}
          onUploaded={onFetchSettings}
          testidPrefix="pprcic"
        />
        <Input
          placeholder="OU: link externo"
          value={formData.pprcic_url}
          onChange={(e) => setFormData(prev => ({ ...prev, pprcic_url: e.target.value }))}
          data-testid="pprcic-url-input"
        />
      </div>
    </CardContent>
  </Card>
);
